import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import LalService from '../service/LalService'

export const initialState = {
  mnoContactList: []
}

export const fetchApplicationList = createAsyncThunk('admin/fetchApplicationList', async () => {
  let applicationsList = await new LalService().getAllApplications();
  return applicationsList;
})

export const fetchNewUserList = createAsyncThunk('admin/getNewUserList', async () => {
  let newUserList = await new LalService().getAllRecentlyCreatedUsers();
  return newUserList;
})

export const fetchUserList = createAsyncThunk('admin/getUserList', async () => {
  let newUserList = await new LalService().getAllUsers();
  return newUserList;
})

export const updateUserRole = createAsyncThunk('admin/updateUserRole', async (user, thunkAPI) => {
  await new LalService().updateUserRole(user);
  thunkAPI.dispatch(fetchUserList())
})

export const deleteUser = createAsyncThunk('admin/deleteUser', async (user, thunkAPI) => {
  await new LalService().deleteUser(user);
  thunkAPI.dispatch(fetchUserList())
})

export const registerUser = createAsyncThunk('admin/registerUser', async (user, thunkAPI) => {
  await new LalService().registerUser(user);
  thunkAPI.dispatch(fetchUserList())
})

export const fetchUserLoginAudit = createAsyncThunk('admin/loginAudit', async () => {
  return await new LalService().getUserLoginAudit();
})

export const fetchMnoContactList = createAsyncThunk('admin/fetchMnoContactList', async () => {
  return await new LalService().getAllMnoContacts();
})

export const updateMnoContact = createAsyncThunk('admin/updateMnoContact', async (contact, thunkAPI) => {
  await new LalService().updateMnoContact(contact)
  thunkAPI.dispatch(fetchMnoContactList())
})

export const deleteMnoContact = createAsyncThunk('admin/deleteMnoContact', async (contact, thunkAPI) => {
  await new LalService().deleteMnoContact(contact)
  thunkAPI.dispatch(fetchMnoContactList())
})

export const createMnoContact = createAsyncThunk('admin/createMnoContact', async (contact, thunkAPI) => {
  await new LalService().createMnoContact(contact)
  thunkAPI.dispatch(fetchMnoContactList())
})

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
  },
  extraReducers: {
    [fetchApplicationList.fulfilled]: (state, action) => {
      state.applicationList = action.payload
    },
    [fetchNewUserList.fulfilled]: (state, action) => {
      state.newUserList = action.payload
    },
    [fetchUserList.fulfilled]: (state, action) => {
      state.userList = action.payload
    },
    [fetchUserLoginAudit.fulfilled]: (state, action) => {
      state.loginAudit = action.payload
    },
    [fetchMnoContactList.fulfilled]: (state,action) => {
      state.mnoContactList = action.payload
    }
  }
})

// No reducers defined yet
// export const { } = adminSlice.actions

export const applicationListSelector = (state) => state.admin?.applicationList
export const newUserListSelector = (state) => state.admin?.newUserList
export const auditListSelector = (state) => state.admin?.loginAudit

export const mnoContactListSelector = (state) => {
  return state.admin?.mnoContactList
}

export default adminSlice.reducer